import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What will the CTO be responsible for?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>A chief technology officer (CTO) should be responsible for adding value to
                                        research and development (R&D) of existing technological approaches and is
                                        supposed to contribute insights. From business analysis to planning – all under
                                        a leadership role – delivering value to everything that falls under the
                                        technological domain.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    Do you need a CTO?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Ideally, if there is heavy reliance on technology and the goal is to be
                                        efficient, utilizing resources to their full potential and upscaling at every
                                        path – the short answer is yes. Reflecting on progress is essential in terms of
                                        growth. A CTO should design technical strategies around critical projects. All
                                        while assessing the risk attached.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    What is CTO as a service?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>CTO as a service (CaaS) stands for the business advisory and technical implementation services provided by a Chief Technology Officer for a startup.</p>
                                    <p>A Chief Technology Officer (CTO) is an executive responsible for addressing a startup's technical requirements and overseeing its research and development efforts.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>
                                    What are the benefits of CTO as a service?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>The primary benefit of choosing CaaS (Chief Technology Officer as a Service) over an in-house CTO is that a company incurs costs only for the services it actually utilizes.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;